import React from 'react';
import ReactDOM from 'react-dom';
import {ConnectedRouter } from 'react-router-redux';
import {Provider} from 'react-redux';
import {Route, Switch} from 'react-router-dom';
import reducers from "./reducers";
import App from './containers/App';
import Page404 from 'app/routes/extraPages/routes/404';
import { store, history } from './store';


ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Switch>
                <Route path="/" component={App}/>
                <Route component={Page404}/>
            </Switch>
        </ConnectedRouter>
    </Provider>, document.getElementById('app-site'));



// WEBPACK FOOTER //
// ./index.js